import {
  useUserContext 
} from "@/context/user"
import mergeOperations from "@/util/shallowMerge"
import {
  useQuery 
} from "@apollo/client"
import {
  useState 
} from "react"

import {
  GET_PRODUCTS_IN_WISHLIST_INFOS 
} from "@/hooks/Wishlist/AddToListButton/addToListButton.gql"
import defaultOperations from "./customerWishlist.gql.ee"

/**
 * A hook that queries for products in a customer's wishlists and maintains a
 * list of skus in a local cache entry.
 *
 * @param {DocumentNode} props.operations operations used to prepare the local customer wishlist array
 * @returns {undefined}
 */
export const useCustomerWishlistSkus = (props = {}) => {
  const operations = mergeOperations(defaultOperations, props.operations)
  const [{
    isSignedIn 
  }] = useUserContext()

  const [currentPage, setCurrentPage] = useState(1)

  const {
    client,
    data: {
      customerWishlistProducts 
    },
  } = useQuery(operations.getProductsInWishlistsQuery)
  const {
    data: {
      customerWishlistProductInfos 
    },
  } = useQuery(GET_PRODUCTS_IN_WISHLIST_INFOS)

  useQuery(operations.getWishlistItemsQuery, {
    fetchPolicy: "cache-and-network",
    onCompleted: (data) => {
      const itemsToAdd = new Set()
      const wishlists = data.customer.wishlists
      const skuMap = customerWishlistProductInfos.reduce((prev, cur) => {
        prev[cur.sku] = 1

        return prev
      }, {})
      const nextCustomerWishlistProductInfos =
                customerWishlistProductInfos.slice()

      let shouldFetchMore = false

      wishlists.map((wishlist) => {
        const items = wishlist.items_v2.items

        items.map((item) => {
          const sku = item.product.sku

          if (!customerWishlistProducts.includes(sku)) {
            itemsToAdd.add(sku)
          }

          if (!skuMap[sku]) {
            nextCustomerWishlistProductInfos.push({
              wishlistId: wishlist.id,
              wishlistItemId: item.id,
              sku,
            })
          }
        })

        const pageInfo = wishlist.items_v2.page_info

        if (pageInfo.total_pages > pageInfo.current_page) {
          shouldFetchMore = true
        }
      })

      if (itemsToAdd.size) {
        client.writeQuery({
          query: operations.getProductsInWishlistsQuery,
          data: {
            customerWishlistProducts: [
              ...customerWishlistProducts,
              ...itemsToAdd,
            ],
          },
        })
      }

      client.writeQuery({
        query: GET_PRODUCTS_IN_WISHLIST_INFOS,
        data: {
          customerWishlistProductInfos:
                        nextCustomerWishlistProductInfos,
        },
      })

      if (shouldFetchMore) {
        setCurrentPage((current) => ++current)
      }
    },
    skip: !isSignedIn,
    variables: {
      currentPage,
    },
  })
}
